module.exports = __webpack_public_path__ + "img/1 (114).973b0c67.png";